import { render, staticRenderFns } from "./PagespeedColorScoreComponent.vue?vue&type=template&id=6bdc3fe8&"
import script from "./PagespeedColorScoreComponent.vue?vue&type=script&lang=js&"
export * from "./PagespeedColorScoreComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports